import { aiTeamRatingActivePageQuery } from '@lib/sanity/queries';
import AiTeamRatingFunnel, {
  createAiTeamRatingStaticProps
} from '@components/quiz/AiTeamRatingFunnel';

/**
 * The standard AI Team Rating funnel — control pricing.
 *
 * Served from whichever quizPage the `aiTeamRatingSettings` singleton points at.
 * The alt-pricing arm lives at /ai-team-rating-v2 and shares this component;
 * only the settings singleton it reads differs.
 */
export const getStaticProps = createAiTeamRatingStaticProps(
  aiTeamRatingActivePageQuery
);

export default AiTeamRatingFunnel;
